import React, { useState } from 'react';
// Components
import Container from '../../Components/Container';
import './DatabasePage.css';

const DatabasePage = () => {

  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [connectionType, setConnectionType] = useState('');
  const [documentationURL, setDocumentationURL] = useState('');
  const [baseURL, setBaseURL] = useState('');
  const [active, setActive] = useState(false);
  const [boolean, setBoolean] = useState(false);
  const [categories, setCategories] = useState('');

  const emptyCredential = {
    value: '',
    credential_type: '',
    name: '',
    location: '',
  };

  const emptyParam = {
    specific_string: '',
    general_field: '',
    name: '',
    location: '',
  };

  const [credentials, setCredentials] = useState(false);
  const [credentialsInfo, setCredentialsInfo] = useState([emptyCredential]);
  const [params, setParams] = useState(false);
  const [paramsInfo, setParamsInfo] = useState([emptyParam]);

  const [record, setRecord] = useState({
    title: '',
    authors: '',
    publication_date: '',
    journal: '',
    keywords: '',
    type: '',
    url: '',
    doi: '',
    abstract: '',
  });

  const [totalCount, setTotalCount] = useState('');
  const [specialMethods, setSpecialMethods] = useState([]);

  const setShowInfo = (resource) => {
    if (resource === 'credential') {
      setCredentials(!credentials);
      if (credentialsInfo.length === 0) {
        setCredentialsInfo([...credentialsInfo, emptyCredential]);
      }
    }
    if (resource === 'param') {
      setParams(!params);
      if (paramsInfo.length === 0) {
        setParamsInfo([...paramsInfo, emptyParam]);
      }
    }
  };

  const addInfo = (value, category, i, resource) => {
    if (resource === 'credential') {
      const info = credentialsInfo;
      info[i][category] = value;
      setCredentialsInfo(info);
    }
    if (resource === 'param') {
      const info = paramsInfo;
      info[i][category] = value;
      setParamsInfo(info);
    }
  };

  const addMoreInfo = (resource) => {
    resource === 'credential' &&
      setCredentialsInfo([...credentialsInfo, emptyCredential]);
    resource === 'param' && setParamsInfo([...paramsInfo, emptyParam]);
  };

  const deleteMoreInfo = (resource) => {
    if (resource === 'credential') {
      credentialsInfo.length === 1 && setCredentials(false);
      const newCredentials = credentialsInfo.slice(0, -1);
      setCredentialsInfo(newCredentials);
    }
    if (resource === 'param') {
      paramsInfo.length === 1 && setParams(false);
      const newParams = paramsInfo.slice(0, -1);
      setParamsInfo(newParams);
    }
  };

  const addResponseInfo = (value, category) => {
    const info = record;
    info[category] = value;
    setRecord(info);
  };

  const handleSubmitResource = () => {
    const getCategories = (categories) => {
      const categoriesList = categories.replaceAll(' ', '').split(';');
      const categoriesResult = [];

      categoriesList.map((categorie) => {
        categoriesResult.push({
          name: categorie,
        });
        return null;
      });
      return categoriesResult;
    };

    const getSpecialMethods = (special_methods) => {
      const categoriesList = special_methods.replaceAll(' ', '').split(';');
      const categoriesResult = [];

      categoriesList.map((categorie) => {
        categoriesResult.push(categorie);
        return null;
      });
      return categoriesResult;
    };

    const JSONresult = {
      code,
      name,
      connection_type: connectionType,
      documentation_url: documentationURL,
      base_url: baseURL,
      active,
      has_boolean_operators: boolean,
      categories: getCategories(categories),
      credencials: credentials ? credentialsInfo : [],
      params: params ? paramsInfo : [],
      responses: [
        {
          body_mapping: {
            'records.array': record,
            count: totalCount,
          },
        },
      ],
      special_methods: getSpecialMethods(specialMethods),
    };
    return JSONresult;
  };
  return (
    <main className='App'>
      <Container>
        <header>
          <h1 className='titleDatabase'>Create Database</h1>
        </header>

        <main className='infoResourceContainer'>
          <form
            className='infoResource'
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmitResource();
            }}
          >
            {/* CODE */}
            <div>
              <h2>Code</h2>
              <input
                required
                type='text'
                placeholder='code Database'
                onChange={(e) => setCode(e.target.value)}
              />
            </div>
            {/* NAME */}
            <div>
              <h2>Name</h2>
              <input
                required
                type='text'
                placeholder='name Database'
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            {/* CONNECTION TYPE */}
            <div>
              <h2>Connection Type</h2>
              <input
                required
                type='text'
                placeholder='connection Type'
                onChange={(e) => setConnectionType(e.target.value)}
              />
            </div>
            {/* DOCUMENTATION URL */}
            <div>
              <h2>Documentation URL</h2>
              <input
                required
                type='text'
                placeholder='documentation URL'
                onChange={(e) => setDocumentationURL(e.target.value)}
              />
            </div>
            {/* BASE URL */}
            <div>
              <h2>Base URL</h2>
              <input
                required
                type='text'
                placeholder='base URL'
                onChange={(e) => setBaseURL(e.target.value)}
              />
            </div>
            {/* ACTIVE */}
            <div className='inputCheckbox'>
              <h2>Active</h2>
              <input
                checked={active}
                type='checkbox'
                onChange={(e) => setActive(!active)}
              />
            </div>
            {/* BOOLEAN */}
            <div className='inputCheckbox'>
              <h2>Has boolean operators</h2>
              <input
                checked={boolean}
                type='checkbox'
                onChange={(e) => setBoolean(!boolean)}
              />
            </div>
            {/* CATEGORIES */}
            <div>
              <h2>Categories</h2>
              <input
                required
                type='text'
                placeholder='categories names'
                onChange={(e) => setCategories(e.target.value)}
              />
            </div>
            {/* CREDENTIALS */}
            <div className='inputCheckbox'>
              <h2>Has credentials</h2>
              <input
                checked={credentials}
                type='checkbox'
                onChange={() => setShowInfo('credential')}
              />
            </div>
            {credentials && (
              <>
                {credentialsInfo.map((credential, i) => {
                  return (
                    <div className='multipleInput' key={i}>
                      <h3>value</h3>
                      <input
                        type='text'
                        required
                        placeholder='value'
                        onChange={(e) =>
                          addInfo(e.target.value, 'value', i, 'credential')
                        }
                      />
                      <h3>credential type</h3>
                      <input
                        type='text'
                        required
                        placeholder='credential type'
                        onChange={(e) =>
                          addInfo(
                            e.target.value,
                            'credential_type',
                            i,
                            'credential'
                          )
                        }
                      />
                      <h3>name</h3>
                      <input
                        type='text'
                        required
                        placeholder='name'
                        onChange={(e) =>
                          addInfo(e.target.value, 'name', i, 'credential')
                        }
                      />
                      <h3>location</h3>
                      <input
                        type='text'
                        required
                        placeholder='location'
                        onChange={(e) =>
                          addInfo(e.target.value, 'location', i, 'credential')
                        }
                      />
                    </div>
                  );
                })}
                <div className='buttonDataContainer'>
                  <button
                    className='addMoreData'
                    onClick={() => addMoreInfo('credential')}
                  >
                    Add credential
                  </button>
                  <button
                    className='deleteData'
                    onClick={() => deleteMoreInfo('credential')}
                  >
                    Delete credential
                  </button>
                </div>
              </>
            )}
            {/* PARAMS */}
            <div className='inputCheckbox'>
              <h2>Has params</h2>
              <input
                checked={params}
                type='checkbox'
                onChange={() => setShowInfo('param')}
              />
            </div>
            {params && (
              <>
                {paramsInfo.map((credential, i) => {
                  return (
                    <div className='multipleInput' key={i}>
                      <h3>value</h3>
                      <input
                        type='text'
                        required
                        placeholder='specific string'
                        onChange={(e) =>
                          addInfo(e.target.value, 'specific_string', i, 'param')
                        }
                      />
                      <h3>credential type</h3>
                      <input
                        type='text'
                        required
                        placeholder='general field'
                        onChange={(e) =>
                          addInfo(e.target.value, 'general_field', i, 'param')
                        }
                      />
                      <h3>name</h3>
                      <input
                        type='text'
                        required
                        placeholder='name'
                        onChange={(e) =>
                          addInfo(e.target.value, 'name', i, 'param')
                        }
                      />
                      <h3>location</h3>
                      <input
                        type='text'
                        required
                        placeholder='location'
                        onChange={(e) =>
                          addInfo(e.target.value, 'location', i, 'param')
                        }
                      />
                    </div>
                  );
                })}

                <div className='buttonDataContainer'>
                  <button
                    className='addMoreData'
                    onClick={() => addMoreInfo('param')}
                  >
                    Add param
                  </button>
                  <button
                    className='deleteData'
                    onClick={() => deleteMoreInfo('param')}
                  >
                    Delete param
                  </button>
                </div>
              </>
            )}
            {/* RESPONSE */}
            <h2>Responses</h2>
            <div className='multipleInput'>
              <h2>Record</h2>
              <h3>title</h3>
              <input
                type='text'
                required
                placeholder='title'
                onChange={(e) => addResponseInfo(e.target.value, 'title')}
              />
              <h3>authors</h3>
              <input
                type='text'
                required
                placeholder='authors'
                onChange={(e) => addResponseInfo(e.target.value, 'authors')}
              />
              <h3>publication date</h3>
              <input
                type='text'
                required
                placeholder='publication date'
                onChange={(e) =>
                  addResponseInfo(e.target.value, 'publication_date')
                }
              />
              <h3>journal</h3>
              <input
                type='text'
                required
                placeholder='journal'
                onChange={(e) => addResponseInfo(e.target.value, 'journal')}
              />
              <h3>keywords</h3>
              <input
                type='text'
                required
                placeholder='keywords'
                onChange={(e) => addResponseInfo(e.target.value, 'keywords')}
              />
              <h3>type</h3>
              <input
                type='text'
                required
                placeholder='type'
                onChange={(e) => addResponseInfo(e.target.value, 'type')}
              />
              <h3>url</h3>
              <input
                type='text'
                required
                placeholder='url'
                onChange={(e) => addResponseInfo(e.target.value, 'url')}
              />
              <h3>doi</h3>
              <input
                type='text'
                required
                placeholder='doi'
                onChange={(e) => addResponseInfo(e.target.value, 'doi')}
              />
              <h3>abstract</h3>
              <input
                type='text'
                required
                placeholder='abstract'
                onChange={(e) => addResponseInfo(e.target.value, 'abstract')}
              />
              <h2 className='countTitle'>Count</h2>
              <input
                type='text'
                required
                placeholder='total'
                onChange={(e) => setTotalCount(e.target.value)}
              />
            </div>
            {/* SPECIAL METHODS */}
            <div>
              <h2>Special Methods</h2>
              <input
                required
                type='text'
                placeholder='Special methods'
                onChange={(e) => setSpecialMethods(e.target.value)}
              />
            </div>
            {/* BUTTON */}
            <button className='buttonTest' type='submit'>
              Show JSON
            </button>
          </form>
        </main>
      </Container>
    </main>
  );
};

export default DatabasePage;
